import React from "react";
import {Box, Divider, Grid, styled, Typography} from "@mui/material";
import {Facebook, Instagram, YouTube} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import useIsMobile from "../hooks/useIsMobile.hook";

const Title = styled(Typography)(() => ({
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 2,
  paddingBottom: '16px'
}));

const Text = styled(Typography)(() => ({
  fontSize: 18,
  fontWeight: 300,
}));

const FooterContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  padding: '0 16px',
  background: '#f3f3f3',
}));


const Link = styled('a')(() => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  color: '#000',
  gap: 6,
  paddingBottom: '8px',
}));

const Footer = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <FooterContainer>
      <Box maxWidth={1200} width="100%">
        <Box sx={{ pb: isMobile ? 0 : 10 }} display="flex" justifyContent="center">
          <Grid container sx={{ padding: '56px 0' }} width="100%" spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <Title>
                {t('bank')}
              </Title>
              <Text><b>{t('bank.receiver')}:</b></Text>
              <Text>Gemeinschaft freier Christusgemeinden e.V.</Text>
              <Text sx={{ mt: 1 }}><b>IBAN:</b></Text>
              <Text>DE24 4526 0475 0012 6367 05</Text>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Title>
                {t('address')}
              </Title>
              <Text>Höftestraße 12, 48167 Münster</Text>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Title>
                {t('contact')}
              </Title>
              <Text>icgms2023@gmail.com</Text>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Title>
                {t('networks')}
              </Title>
              <Link href="https://www.facebook.com/share/rQwXM9dpanNsKYY1/?mibextid=LQQJ4d" target="_blank">
                <Facebook/>
                <Text>Facebook</Text>
              </Link>
              <Link href="https://www.instagram.com/int.christus.gemeindemuenster_?igsh=Mmx6bW0xbHMzMnhj&utm_source=qr" target="_blank">
                <Instagram/>
                <Text>Instagram</Text>
              </Link>
              <Link href="https://www.youtube.com/@int.christusgemeindems" target="_blank">
                <YouTube/>
                <Text>YouTube</Text>
              </Link>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        <Box sx={{ padding: '34px 0' }}>
          <Typography fontSize={isMobile ? 12 : 18}>
            © {new Date().getFullYear()} Internationale Christusgemeinde MS. Alle Rechte vorbehalten.
          </Typography>
        </Box>
      </Box>
    </FooterContainer>
  );
};

export default Footer;
